/**
 * Tutorial guidato dell'elenco Ticket.
 *
 * I tre pallini della riga si raccontano illuminando il pulsante e non la voce
 * dentro il menu: un menu di Vuetify aperto dal tutorial si richiude da solo, perche'
 * il click programmatico e quello su "Avanti" arrivano a `document` a un soffio di
 * distanza. Il tutorial non apre nessun ticket: la riga intera e' cliccabile e
 * aprirebbe il dettaglio.
 */
const SCOPE = '[data-tour-scope="tickets"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createTicketsTourSteps() {
	return [
		{
			body: "I ticket sono le richieste di assistenza aperte verso chi gestisce la piattaforma: un problema, una domanda, una cosa che non torna. Ogni riga e' una conversazione, non un singolo messaggio.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I ticket di assistenza',
		},
		{
			body: "Il piu' in alto apre la scheda per aprire un ticket nuovo: oggetto, messaggio e, se serve, immagini o un video di quello che succede. La scheda ha un tutorial suo.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aprire un ticket',
		},
		{ body: 'La ricerca filtra per oggetto e contenuto: premi Invio o la lente per applicarla.', key: 'search', placement: 'bottom', target: at('search'), title: 'Cercare un ticket' },
		{
			body: "Le pastiglie accanto alla ricerca filtrano per stato: aperto, in lavorazione, in attesa, chiuso. Tutti riporta l'elenco completo - e' il filtro che si usa piu' spesso, perche' un ticket chiuso sparisce dalla vista ma non dall'archivio.",
			key: 'filters',
			placement: 'bottom',
			target: at('filters'),
			title: 'Filtrare per stato',
		},
		{
			body: "La tabella mostra lo stato, l'oggetto con l'inizio del messaggio, chi ha aperto il ticket, quando e l'ultimo aggiornamento. Quest'ultima colonna e' quella da guardare: dice se la palla e' ancora in campo.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: 'Per aprire un ticket basta cliccare la riga, da qualsiasi punto: si apre il dettaglio con tutta la conversazione. I tre pallini a inizio riga fanno la stessa cosa con Dettaglio, e aggiungono Elimina - che toglie il ticket e i suoi messaggi per sempre.',
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Aprire o eliminare',
		},
		{
			body: "L'elenco arriva una pagina per volta dal server: da qui cambi pagina e quante righe vedere.",
			key: 'pagination',
			placement: 'top',
			target: `${SCOPE} .v-data-footer`,
			timeout: 400,
			title: "Sfogliare l'elenco",
		},
	];
}
